<mat-form-field>
  <mat-select placeholder="FieldMapping" #select>
    <mat-option>- Keine -</mat-option>
    <mat-option *ngFor="let fieldmapping of dmsFieldMappings" [value]="fieldmapping">
      {{ fieldmapping }}
    </mat-option>
  </mat-select>
</mat-form-field>
